export default __webpack_public_path__ + "static/media/onboarding.55046967.png";